(function () {
  var BODY_CLASS = 'top-bar-hidden';

  function init() {
    var topBar = document.querySelector('.top_bar.js-hide-when-scroll');
    if (!topBar) return;

    function isHidden() {
      return topBar.classList.contains('hidden') ||
             window.getComputedStyle(topBar).display === 'none';
    }

    function sync() {
      document.body.classList.toggle(BODY_CLASS, isHidden());
    }

    new MutationObserver(sync).observe(topBar, {
      attributes: true,
      attributeFilter: ['class', 'style']
    });

    sync();
    window.addEventListener('resize', sync);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();